/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { ReplaceOneBaseAodRulesControllerAodRuleMutationRequest, ReplaceOneBaseAodRulesControllerAodRuleMutationResponse, ReplaceOneBaseAodRulesControllerAodRulePathParams } from "../models/ReplaceOneBaseAodRulesControllerAodRule";

export function getReplaceOneBaseAodRulesControllerAodRuleUrl(id: ReplaceOneBaseAodRulesControllerAodRulePathParams["id"]) {
  const res = { method: 'PUT', url: `/aod-rules/${id}` as const }
  return res
}

/**
 * @summary Replace a single AodRule
 * {@link /aod-rules/:id}
 */
export async function replaceOneBaseAodRulesControllerAodRule(id: ReplaceOneBaseAodRulesControllerAodRulePathParams["id"], data: ReplaceOneBaseAodRulesControllerAodRuleMutationRequest, config: Partial<RequestConfig<ReplaceOneBaseAodRulesControllerAodRuleMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ReplaceOneBaseAodRulesControllerAodRuleMutationResponse, ResponseErrorConfig<Error>, ReplaceOneBaseAodRulesControllerAodRuleMutationRequest>({ method : "PUT", url : getReplaceOneBaseAodRulesControllerAodRuleUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}